export default function InputError({ message, className = "" }) {
  return message ? (
    <p className={`text-sm text-destructive mt-1 ${className}`}>
      {message}
    </p>
  ) : null
}
